let marker = document.querySelector("#marker2");
let marker2 = document.querySelector("#marker4");
let marker3 = document.querySelector("#marker6");
let tabItem = document.querySelectorAll(".box8-tab a");
let tabItem2 = document.querySelectorAll(".box9-tab a");
let tabItem3 = document.querySelectorAll(".box9-2-tab a");
let tabItemContent = document.querySelectorAll(".box8-tab-c-item");
let tabItemContent2 = document.querySelectorAll(".box9-tab-c-item");
let tabItemContent3 = document.querySelectorAll(".box9-2-tab-c-item");

let box3TabItem = document.querySelectorAll(".box3-info .tab-list .tab-item");
let box3TabContent = document.querySelectorAll(
	".box3-info .tab-content .tab-content-item"
);

let box4TabItem = document.querySelectorAll(".box4-info .tab-list .tab-item");
let box4TabContent = document.querySelectorAll(
	".box4-info .tab-content .tab-content-item"
);

let box7TabItem = document.querySelectorAll(".box7-info .tab-list .tab-item");
let box7TabContent = document.querySelectorAll(
	".box7-info .tab-content .tab-content-item"
);
let box7TabDescription = document.querySelectorAll(
	".box7-info .tab-description p"
);

for (let i = 0; i < box3TabItem.length; i++) {
	box3TabItem[i].addEventListener("click", () => {
		box3TabItem.forEach((item) => {
			item.classList.remove("active");
		});
		box3TabContent.forEach((item) => {
			item.classList.remove("active");
		});

		box3TabItem[i].classList.add("active");
		box3TabContent[i].classList.add("active");
	});
	box3TabItem[i].addEventListener("mouseover", (e) => {
		box3TabItem.forEach((item) => {
			item.classList.remove("active");
		});
		box3TabContent.forEach((item) => {
			item.classList.remove("active");
		});

		box3TabItem[i].classList.add("active");
		box3TabContent[i].classList.add("active");
	});
}

for (let i = 0; i < box4TabItem.length; i++) {
	box4TabItem[i].addEventListener("click", () => {
		box4TabItem.forEach((item) => {
			item.classList.remove("active");
		});
		box4TabContent.forEach((item) => {
			item.classList.remove("active");
		});

		box4TabItem[i].classList.add("active");
		box4TabContent[i].classList.add("active");
	});
}

for (let i = 0; i < box7TabItem.length; i++) {
	box7TabItem[i].addEventListener("click", () => {
		box7TabItem.forEach((item) => {
			item.classList.remove("active");
		});
		box7TabContent.forEach((item) => {
			item.classList.remove("active");
		});
		box7TabDescription.forEach((item) => {
			item.classList.remove("active");
		});

		box7TabItem[i].classList.add("active");
		box7TabContent[i].classList.add("active");
		box7TabDescription[i].classList.add("active");
	});
}

function indicator(e) {
	marker.style.left = e.offsetLeft + "px";
	marker.style.width = e.offsetWidth + "px";
}

tabItem.forEach((link, index) => {
	link.addEventListener("click", (e) => {
		indicator(e.target);

		tabItemContent.forEach((item) => {
			item.classList.remove("box8-active");
		});
		tabItem.forEach((item) => {
			item.classList.remove("box8-tab-active");
		});

		tabItem[index].classList.add("box8-tab-active");
		tabItemContent[index].classList.add("box8-active");
	});

	link.addEventListener("mouseover", (e) => {
		indicator(e.target);

		tabItemContent.forEach((item) => {
			item.classList.remove("box8-active");
		});
		tabItem.forEach((item) => {
			item.classList.remove("box8-tab-active");
		});

		tabItem[index].classList.add("box8-tab-active");
		tabItemContent[index].classList.add("box8-active");
	});
});

function indicator2(e) {
	marker2.style.left = e.offsetLeft + "px";
	marker2.style.width = e.offsetWidth + "px";
}

tabItem2.forEach((link, index) => {
	link.addEventListener("click", (e) => {
		indicator2(e.target);

		tabItemContent2.forEach((item) => {
			item.classList.remove("box9-active");
		});
		tabItem2.forEach((item) => {
			item.classList.remove("box9-tab-active");
		});

		tabItem2[index].classList.add("box9-tab-active");
		tabItemContent2[index].classList.add("box9-active");
	});

	link.addEventListener("mouseover", (e) => {
		indicator2(e.target);

		tabItemContent2.forEach((item) => {
			item.classList.remove("box9-active");
		});
		tabItem2.forEach((item) => {
			item.classList.remove("box9-tab-active");
		});

		tabItem2[index].classList.add("box9-tab-active");
		tabItemContent2[index].classList.add("box9-active");
	});
});

function indicator3(e) {
	marker3.style.left = e.offsetLeft + "px";
	marker3.style.width = e.offsetWidth + "px";
}

tabItem3.forEach((link, index) => {
	link.addEventListener("click", (e) => {
		indicator3(e.target);

		tabItemContent3.forEach((item) => {
			item.classList.remove("box9-2-active");
		});
		tabItem3.forEach((item) => {
			item.classList.remove("box9-2-tab-active");
		});

		tabItem3[index].classList.add("box9-2-tab-active");
		tabItemContent3[index].classList.add("box9-2-active");
	});

	link.addEventListener("mouseover", (e) => {
		indicator3(e.target);

		tabItemContent3.forEach((item) => {
			item.classList.remove("box9-2-active");
		});
		tabItem3.forEach((item) => {
			item.classList.remove("box9-2-tab-active");
		});

		tabItem3[index].classList.add("box9-2-tab-active");
		tabItemContent3[index].classList.add("box9-2-active");
	});
});

let but = document.querySelectorAll(".buy-now_but");
let butView = document.querySelector("#box10");

but.forEach((item) => {
	item.addEventListener("click", function () {
		butView.scrollIntoView({ behavior: "smooth" });
	});
});

let termIs = false;
let emailIs = false;
let countryIs = false;
let newsletterIs = false;
let form_email = "";

document.getElementById("title").addEventListener("blur", function () {
	if (this.value.trim() === "") {
		document.querySelector("#title").style.borderColor = "red";
	} else {
		document.querySelector("#title").style.borderColor = "#cbcbcb";
	}
});
document.getElementById("name").addEventListener("blur", function () {
	if (this.value.trim() === "") {
		document.querySelector("#name").style.borderColor = "red";
	} else {
		document.querySelector("#name").style.borderColor = "#cbcbcb";
	}
});
document.getElementById("email").addEventListener("blur", function () {
	if (this.value.trim() === "") {
		document.querySelector("#email").style.borderColor = "red";
	} else {
		const emailInput = document.getElementById("email");
		const email = emailInput.value.trim();

		// 正则表达式用于验证邮箱格式
		const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

		if (email === "") {
			document.querySelector("#email").style.borderColor = "red";
		} else if (!emailPattern.test(email)) {
			document.querySelector("#email").style.borderColor = "red";
		} else {
			document.querySelector("#email").style.borderColor = "#cbcbcb";
			emailIs = true;
		}
	}
});
document.getElementById("phone").addEventListener("blur", function () {
	if (this.value.trim() === "") {
		document.querySelector("#phone").style.borderColor = "red";
	} else {
		document.querySelector("#phone").style.borderColor = "#cbcbcb";
	}
});

$("#country").on("change", function () {
	var selectedValue = $(this).val();
	if (selectedValue) {
		$(".select2-container--default .select2-selection--single").css(
			"border-color",
			"#cbcbcb"
		);
		countryIs = true;
	} else {
		// $('.select2-container--default .select2-selection--single').css('border-color','red')
	}
});

document.getElementById("company").addEventListener("blur", function () {
	if (this.value.trim() === "") {
		document.querySelector("#company").style.borderColor = "red";
	} else {
		document.querySelector("#company").style.borderColor = "#cbcbcb";
	}
});
document.getElementById("industry").addEventListener("blur", function () {
	if (this.value.trim() === "") {
		document.querySelector("#industry").style.borderColor = "red";
	} else {
		document.querySelector("#industry").style.borderColor = "#cbcbcb";
	}
});

document.getElementById("term").addEventListener("click", (e) => {
	let checked = document.getElementById("term").checked;
	if (checked) {
		document.querySelector(".form-submit").style.backgroundColor =
			"#CE643D";
		termIs = true;
	} else {
		document.querySelector(".form-submit").style.backgroundColor =
			"#b3b3b3";
		termIs = false;
	}
});
document.getElementById("newsletter").addEventListener("click", (e) => {
	let checked = document.getElementById("newsletter").checked;
	if (checked) {
		newsletterIs = true;
	} else {
		newsletterIs = false;
	}
});

document.getElementById("form-submit").addEventListener("click", (e) => {
	if (termIs) {
		const form = document.querySelector("#box10-form");
		const formData = new FormData(form);

		var title = formData.get("title");
		var name = formData.get("name");
		var email = formData.get("email");
		var countryCode = iti.getSelectedCountryData().dialCode;
		var phoneNumber = input.value.replace(/\D/g, "");

		var country = formData.get("country");
		var company = formData.get("company");
		var industry = formData.get("industry");
		var model = formData.get("model");
		var many = formData.get("many");
		var timeBuy = formData.get("timeBuy");
		var detail = formData.get("detail");
		var term = formData.get("term");
		newsletter = formData.get("newsletter");

		let data = {
			title,
			name,
			email,
			countryCode,
			phoneNumber,
			country,
			company,
			industry,
			model,
			many,
			timeBuy,
			detail,
			term,
		};

		let required = true;

		if (!title) {
			document.querySelector("#title").style.borderColor = "red";
			required = false;
		}
		if (!name) {
			document.querySelector("#name").style.borderColor = "red";
			required = false;
		}
		if (!email || !emailIs) {
			document.querySelector("#email").style.borderColor = "red";
			required = false;
		}
		if (!countryCode) {
			document.querySelector("#phone").style.borderColor = "red";
			required = false;
		}
		if (!phoneNumber) {
			document.querySelector("#phone").style.borderColor = "red";
			required = false;
		}
		if (!country || !countryIs) {
			$(".select2-container--default .select2-selection--single").css(
				"border-color",
				"red"
			);
			required = false;
		}
		if (!company) {
			document.querySelector("#company").style.borderColor = "red";
			required = false;
		}
		if (!industry) {
			document.querySelector("#industry").style.borderColor = "red";
			required = false;
		}

		if (required == false) {
			document.querySelector(".required-text").style.display = "block";
		} else {
			document.querySelector(".required-text").style.display = "none";
			sendEmail(data);
		}
	}
});

function sendEmail(data) {
	form_email = data.email;

	document.body.style.overflow = "hidden";
	$(".loading-z").css("display", "block");

	let timeBuy = "";

	if (data.timeBuy === "timeBuy1") {
		timeBuy = "Less than one month";
	}
	if (data.timeBuy === "timeBuy2") {
		timeBuy = " 1-6 months";
	}
	if (data.timeBuy === "timeBuy3") {
		timeBuy = "6+ months";
	}
	if (data.timeBuy === "timeBuy4") {
		timeBuy = "Not sure";
	}

	let countryText = "";

	countryArr.map((item) => {
		if (item.id == data.country) {
			countryText = item.text;
		}
	});

	countryData.forEach((item) => {
		if (item.country === countryText) {
			let emailTitle = `Business Enquiry from ${data.name} ${data.company}`;

			let emailContent = `
      <div style="width: 600px">
      <div style="margin-bottom: 10px;"><div style="font-weight: 600;">Title: </div><div>${
			data.title
		}</div></div>
      <div style="margin-bottom: 10px;"><div style="font-weight: 600;">Name: </div><div>${
			data.name
		}</div></div>
      <div style="margin-bottom: 10px;"><div style="font-weight: 600;">Business Email: </div><div>${
			data.email
		}</div></div>
      <div style="margin-bottom: 10px;"><div style="font-weight: 600;">Phone Number: </div><div>+${
			data.countryCode
		} - ${data.phoneNumber}</div></div>
      <div style="margin-bottom: 10px;"><div style="font-weight: 600;">Country/Region: </div><div>${
			data.country
		} / ${item.region}</div></div>
      <div style="margin-bottom: 10px;"><div style="font-weight: 600;">Company/Institute: </div><div>${
			data.company
		}</div></div>
      <div style="margin-bottom: 10px;"><div style="font-weight: 600;">Industry: </div><div>${
			data.industry
		}</div></div>
      <div style="margin-bottom: 10px;"><div style="font-weight: 600;">Which model are you interested in?</div><div>${
			data.model || "null"
		}</div></div>
      <div style="margin-bottom: 10px;"><div style="font-weight: 600;">How many BOOX devices are you considering to buy?</div><div>${
			data.many || "null"
		}</div></div>
      <div style="margin-bottom: 10px;"><div style="font-weight: 600;">When do you plan to buy?</div><div>${
			timeBuy || "null"
		}</div></div>
      <div style="margin-bottom: 10px;"><div style="font-weight: 600;">Detail: </div><div>${
			data.detail || "null"
		}</div></div>
    </div>
      `;

			let params = {
				emailTitle: emailTitle,
				title: data.title,
				name: data.name,
				email: data.email,
				countryCode: data.countryCode,
				phoneNumber: data.phoneNumber,
				country: countryText,
				region: item.region,
				company: data.company,
				industry: data.industry,
				model: data.model || "null",
				many: data.many || "null",
				timeBuy: timeBuy || "null",
				detail: data.detail || "null",
				toEmail: item.email,
			};
			// toEmail: item.email,
			const serviceID = "service_pz0ryw8";
			const templateID = "template_tbxnkao";

			emailjs
				.send(serviceID, templateID, params)
				.then((res) => {
					$(".loading-z").css("display", "none");
					document.body.style.overflow = "";
					if (res.status === 200) {
						document.querySelector(".overlay").style.display =
							"flex";
						if (newsletter) {
							document.querySelector("#data-text").style.display =
								"block";
							redirecting(form_email);
						} else {
							document.querySelector("#data-text").style.display =
								"none";
						}
					}
				})
				.catch((err) => {
					$(".loading-z").css("display", "none");
					document.body.style.overflow = "";
					console.log(err);
				});
		}
	});
}

function closePopup() {
	toUrl();
	document.body.style.overflow = "";
}

function redirecting(email) {
	if (newsletterIs) {
		let inputElement = document.getElementById("NewsletterForm--business");
		let timeLeft = 3;
		let dataS = document.getElementById("dataS");

		inputElement.value = email;

		const interval = setInterval(function () {
			if (timeLeft > 0) {
				dataS.textContent = timeLeft;
				timeLeft--;
			} else {
				clearInterval(interval);
				dataS.textContent = "0";
				toUrl();
			}
		}, 1000);
	}
}

function toUrl() {
	document.querySelector(".overlay").style.display = "none";
	if (newsletterIs) {
		document.querySelector('#b-form form input[type="submit"]').click();
	}
}
